import { connect, useDispatch } from "react-redux";
import { IReports } from "../../../../models/master/reports";
import { useEffect } from "react";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { ReportFrequency } from "../../../../models/dashboard/adminDashboard";
import { setReportsYearly } from "../../../../store/slices/master/reportSlice";
import { getReports } from "../../../../action/masters/reportActionCreator";
import { baseURL } from "../../../../constants/commonConstants";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { IYearlyReports } from "../../../../models/dashboard/staffReports/staffReports";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const StaffAnnuallyReport = (props: IYearlyReports) => {
  const { getYearlyReports, yearlyReports, snapShots } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleViewALL = () => {
    navigate(ROUTER_URL.STAFF_ALL_ANNUALLY_REPORTS);
  };

  const pageBlockData = getPageBlockData(
    snapShots,
    pageBlockId.reportResources
  );

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getYearlyReports(
        pageBlockId.reportResources,
        limit.three,
        ReportFrequency.Yearly
      );
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setReportsYearly([]));
    };
  }, []);
  return (
    <>
      <div className="col-lg-12 mt-3">
        <div
          className={
            pageBlockData?.displayOrNot
              ? "card-wrap"
              : "card-wrap card-snapshot"
          }
          style={
            pageBlockData?.displayOrNot === false
              ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
              : {}
          }
        >
          <div className="title">
            <h2>Monthly and Annual Reports</h2>
            <a
              onClick={handleViewALL}
              className={
                pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
              }
              title="View Annually Report"
            >
              View All
            </a>
          </div>
          <div className="acc-resource mt-3 row">
            {yearlyReports?.map((report: IReports) => (
              <div className="col-lg-4" key={report.id}>
                <a href={report.url} target="_blank">
                  <div className="card d-flex align-items-start flex-column">
                    <div className="reportimg">
                      <img src={baseURL + report.icon} alt="" />
                    </div>
                    <h2 className="para-hide-1">{report.name}</h2>
                    <p className="para-hide-2">{report.description}</p>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getYearlyReports: (
    pageBlockId: number,
    noOfItems: number,
    ReportFrequency: number
  ) => getReports(undefined, pageBlockId, noOfItems, ReportFrequency),
};

function mapStateToProps(state: any) {
  return {
    yearlyReports: state.report.yearlyreports,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StaffAnnuallyReport);
